export default __webpack_public_path__ + "static/image-2021-12-21-10-15-22-175-787797d75c9d5a7efb34e933a8fa30ff.png";